var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-4 pb-2",staticStyle:{"font-size":"15px"}},_vm._l((_vm.items),function(item){return _c('div',{key:item.name},[_c('div',[_vm._v(_vm._s(item.name)+": "+_vm._s(item.version))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }